import React from 'react';
import { Mail, MapPin, MessageCircle } from 'lucide-react';
import { footerContent } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/918591732501?text=Hi%20Ukiyo%20Tours!%20I%27d%20like%20to%20know%20more.', '_blank');
  };

  return (
    <footer id="contact" className="bg-[#1e3a5f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Section */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_64492122-1ef3-4521-a66d-df97c836c1aa/artifacts/fa6ost47_Ukiyo_Logo.png" 
              alt="Ukiyo Tours" 
              className="h-28 w-auto mb-4 brightness-0 invert"
            />
            <h3 className="text-xl font-bold mb-2">{footerContent.companyName}</h3>
            <p className="text-[#c9a961] font-medium mb-2">{footerContent.tagline}</p>
            <p className="text-white/80">{footerContent.destinations}</p>
          </div>

          {/* Contact Section */}
          <div>
            <h4 className="text-lg font-bold mb-4">Get In Touch</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <MapPin className="text-[#c9a961] flex-shrink-0" size={20} />
                <span className="text-white/80">{footerContent.location}</span>
              </div>
              <a 
                href={`mailto:${footerContent.email}`}
                className="flex items-center space-x-3 hover:text-[#c9a961] transition-colors duration-300"
              >
                <Mail className="text-[#c9a961] flex-shrink-0" size={20} />
                <span className="text-white/80 hover:text-[#c9a961]">{footerContent.email}</span>
              </a>
              <button 
                onClick={handleWhatsAppClick}
                className="flex items-center space-x-3 hover:text-[#c9a961] transition-colors duration-300"
              >
                <MessageCircle className="text-[#c9a961] flex-shrink-0" size={20} />
                <span className="text-white/80 hover:text-[#c9a961]">Chat on WhatsApp</span>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <button 
                onClick={() => document.getElementById('destinations').scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/80 hover:text-[#c9a961] transition-colors duration-300"
              >
                Destinations
              </button>
              <button 
                onClick={() => document.getElementById('featured-package').scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/80 hover:text-[#c9a961] transition-colors duration-300"
              >
                Packages
              </button>
              <button 
                onClick={() => document.getElementById('why-ukiyo').scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/80 hover:text-[#c9a961] transition-colors duration-300"
              >
                Why Us
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white/60 text-sm">
            © {currentYear} {footerContent.companyName}. All rights reserved.
          </p>
          <p className="text-white/60 text-sm">
            {footerContent.venture}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
